import { useCallback, useEffect, useState } from "react";
import { BellRing, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

const when = (iso) => new Date(iso).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" });

export function NotificationGate() {
  const [unread, setUnread] = useState([]);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => api.get("/notifications").then((r) => setUnread(r.data.unread)).catch(() => {}), []);
  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    const onVis = () => document.visibilityState === "visible" && load();
    document.addEventListener("visibilitychange", onVis);
    return () => { clearInterval(t); document.removeEventListener("visibilitychange", onVis); };
  }, [load]);
  const n = unread[0];
  if (!n) return null;
  const confirm = async () => {
    setBusy(true);
    await api.post(`/notifications/${n.id}/read`).catch(() => {});
    const jobId = n.tag?.startsWith("plan-") && n.url?.match(/\/tecnico\/intervento\/([^/?#]+)/)?.[1];
    if (jobId) await api.post(`/jobs/${jobId}/plan-read`).catch(() => {});
    setBusy(false);
    setUnread((u) => u.slice(1));
  };
  return (
    <Dialog open onOpenChange={() => {}}>
      <DialogContent className="max-w-sm [&>button]:hidden" data-testid="notification-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><BellRing className="h-5 w-5 text-[#61a229]" /> {n.title}</DialogTitle>
          <DialogDescription className="text-left text-sm" data-testid="notification-body">{n.body}</DialogDescription>
        </DialogHeader>
        <p className="text-xs text-slate-400">Ricevuta il {when(n.created_at)}{unread.length > 1 ? ` · altre ${unread.length - 1} da leggere` : ""}</p>
        <div>
          <Button onClick={confirm} disabled={busy} className="w-full rounded-full bg-[#61a229] hover:bg-[#528a22]" data-testid="notification-confirm">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Confermo la lettura
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
